"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styles_1 = require("@material-ui/core/styles");
const react_1 = tslib_1.__importDefault(require("react"));
const jss_1 = require("jss");
const jss_rtl_1 = tslib_1.__importDefault(require("jss-rtl"));
// Configure JSS
const jss = jss_1.create({ plugins: [...styles_1.jssPreset().plugins, jss_rtl_1.default()] });
const withRTL = (Component) => (props) => {
    return (react_1.default.createElement(styles_1.StylesProvider, { jss: jss },
        react_1.default.createElement(Component, Object.assign({}, props))));
};
exports.default = withRTL;
